let c = null;
async function t() {
  if (!c) {
    const i = await import("./quicklink-deafa8ab.mjs");
    c = i.default || i;
  }
  return c;
}
async function a(i = {}) {
  try {
    (await t()).listen(i);
  } catch (n) {
    throw console.error("❌ Failed to initialize Quicklink:", n), n;
  }
}
async function e(i, n = !1) {
  (await t()).prefetch(i, n);
}
async function k(i) {
  (await t()).prerender(i);
}
export {
  k as a,
  a as i,
  e as p
};
